<template>
    <div class="">
        <div class="flex items-center justify-between uppercase">
            <span>{{ props.title }}</span>
            <span>{{ props.subTitle }}</span>
        </div>
        <div class="w-full h-[2px] bg-primary mt-2"></div>
    </div>
</template>

<script setup>

const props = defineProps({
    title: {
        type: String,
    },
    subTitle: {
        type: String,
    },
})
</script>
<style scoped>

</style>